export enum PopMessageActionsTypes {
  ADD_POP_MESSAGE = "ADD_POP_MESSAGE",
  REMOVE_POP_MESSAGE = "REMOVE_POP_MESSAGE",
}
